"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_EVENTS = {
    TICK_RECEIVED: "tick_received",
    CONNECTED: "connected",
    DISCONNECTED: "disconnected",
    UNAVAILABLE: "unavailable",
    AUTHENTICATED: "authenticated",
    AUTHENTICATION_FAILED: "authentication_failed",
    AUTHENTICATION_ABORTED: "authentication_aborted",
    SUBSCRIPTION_SUCCEEDED: "pusher:subscription_succeeded",
    SUBSCRIPTION_FAILED: "pusher:subscription_failed",
};
exports.SERVER_EVENTS = {
    UP: {
        AUTH_REQUEST: "quoine:auth_request",
        SUBSCRIBE: "pusher:subscribe",
        UNSUBSCRIBE: "pusher:unsubscribe",
        PING: "pusher:ping",
    },
    DOWN: {
        SUBSCRIPTION_SUCCEEDED: "pusher_internal:subscription_succeeded",
        SUBSCRIPTION_FAILED: "pusher:error",
        CONNECTION_ESTABLISHED: "pusher:connection_established",
        AUTH_SUCCESS: "quoine:auth_success",
        AUTH_FAILURE: "quoine:auth_failure",
        PONG: "pusher:pong",
    },
};
exports.CONNECTION_STATE = {
    INITIALIZED: "waiting",
    CONNECTING: "connecting",
    RECONNECTING: "reconnecting",
    CONNECTED: "connected",
    UNAVAILABLE: "unavailable",
    FAILED: "failed",
    DISCONNECTED: "disconnected",
};
